<template>
<!-- 拼团 -->
    <div class="el-card  pd20">
        <!-- add---新增 -->
        <div class="add-box">
            <router-link to="/main/course_quote_form">
                <el-button type="primary" size="medium">创建课程联报</el-button>
            </router-link>
        </div>
        <!--  -->
        <div class="el-card  pd20 content">
            <el-table :data="list" border style="width: 100%">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column type="index" width="55" label="序号"></el-table-column>
                <el-table-column  label="联报课程" width="200">
                    <template slot-scope="scope">
                        <span v-html="scope.row.courseName"></span>
                    </template>
                </el-table-column>
                <el-table-column prop="favorable" label="优惠价格" > </el-table-column>
                <el-table-column prop="commission_sum" label="联报佣金" ></el-table-column>
                <el-table-column prop="refund_rule" label="退款规则" ></el-table-column>
                <el-table-column prop="url" label="联报链接" > </el-table-column>
                <el-table-column  label="状态" width="80">
                    <template slot-scope="scope">
                        <el-tag size="small" v-if="scope.row.state==0" type="success">开启</el-tag>
                        <el-tag size="small" v-if="scope.row.state==1"  type="info">关闭</el-tag>
                    </template>
                </el-table-column>
                <el-table-column width="180"  label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" icon="el-icon-edit" @click="edit(scope.$index, scope.row,'edit')" circle></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination class="pages"
                :page-sizes="[25, 50, 75, 100]"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="pages.size"
                :current-page="pages.page"
                background
                layout="sizes,prev, pager, next"
                :total="pages.count">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { joint_course_list } from "@/api/course";
export default {
    data() {
        return{
            pages:{},
            list:[],
            //
            course_id:null,
            status:null,
            // 所有课程列表
            course_list:[],
            obj:{}
        }
    },
    methods:{
        edit(index,row){
            this.$router.push({
                path:'/main/course_quote_form',
                query:{
                    id:row.id
                }
            });
        },
         // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        },
        pullData(){
            this.$showLoading();
            this.obj = {
                page:Object.keys(this.pages).length>0?this.pages.page:1,  //页码，默认1
                size:Object.keys(this.pages).length>0?this.pages.size:25   //每页数量，默认25
            };

            joint_course_list()
            .then((data)=>{
                this.list = data.list;
                this.pages = data.pager;
                for(let arg of this.list){
                    arg.commission_sum = 0;
                    for(let attr of arg.config){
                        arg.commission_sum += attr.commission;
                    }
                }
                this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.add-box{
    margin-bottom: 20px;
    display: flex;
}
.content{
    padding: 20px;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.search{
    margin-left: auto;
    text-align: right;
}
.search-child{
    margin-left: 20px;
}
</style>
